"use strict";

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
tinymce.addI18n("ro", {
  Cut: "Taie",
  "Heading 5": "Titlu 5",
  "Header 2": "Antet 2",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Browser-ul dumneavoastr\u0103 nu support\u0103 acces direct la clipboard. Folosi\u0163i combina\u0163ile de tastatur\u0103 Ctrl+X/C/V.",
  "Heading 4": "Titlu 4",
  Div: "Div",
  "Heading 2": "Titlu 2",
  Paste: "Insereaz\u0103",
  Close: "\xCEnchide",
  "Font Family": "Familie font",
  Pre: "Pre",
  "Align right": "Aliniere la dreapta",
  "New document": "Document nou",
  Blockquote: "Citat",
  "Numbered list": "List\u0103 ordonat\u0103",
  "Heading 1": "Titlu 1",
  Headings: "Titluri",
  "Increase indent": "Indenteaz\u0103",
  Formats: "Formate",
  Headers: "Antete",
  "Select all": "Selecteaz\u0103 tot",
  "Header 3": "Antet 3",
  Blocks: "Blocuri",
  Undo: "Ref\u0103 la loc",
  Strikethrough: "T\u0103iat",
  "Bullet list": "List\u0103 neordonat\u0103",
  "Header 1": "Antet 1",
  Superscript: "Superscript",
  "Clear formatting": "\u015Eterge format\u0103rile",
  "Font Sizes": "Dimensiuni font",
  Subscript: "Subscript",
  "Header 6": "Antet 6",
  Redo: "Execut\u0103 din nou",
  Paragraph: "Paragraf",
  Ok: "Ok",
  Bold: "\xCEngro\u015Fat",
  Code: "Cod",
  Italic: "Italic",
  "Align center": "Centrare",
  "Header 5": "Antet 5",
  "Heading 6": "Titlu 6",
  "Heading 3": "Titlu 3",
  "Decrease indent": "De-indenteaz\u0103",
  "Header 4": "Antet 4",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Functia \"lipe\u015Fte\" este acum \xEEn modul text simplu. Continutul va fi acum inserat ca text simplu p\xE2n\u0103 c\xE2nd aceast\u0103 op\u021Biune va fi dezactivat.",
  Underline: "Subliniat",
  Cancel: "Anuleaz\u0103",
  Justify: "Aliniere pe toat\u0103 l\u0103\u021Bimea",
  Inline: "Inline",
  Copy: "Copiaz\u0103",
  "Align left": "Aliniere la st\xE2nga",
  "Visual aids": "Ajutor vizual",
  "Lower Greek": "Minuscule Grecesti",
  Square: "P\u0103trat",
  Default: "Implicit",
  "Lower Alpha": "Minuscule Alfanumerice",
  Circle: "Cerc",
  Disc: "Disc",
  "Upper Alpha": "Majuscule Alfanumerice",
  "Upper Roman": "Majuscule Romane",
  "Lower Roman": "Minuscule Romane",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "Id-ul trebuie s\u0103 inceap\u0103 cu o liter\u0103, urmat\u0103 exclusiv de litere, numere, cratime, puncte, punct \u0219i virgul\u0103 sau underscore-uri.",
  Name: "Nume",
  Anchor: "Ancor\u0103",
  Id: "Id",
  "You have unsaved changes are you sure you want to navigate away?": "Ave\u021Bi modific\u0103ri nesalvate! Sunte\u0163i sigur c\u0103 dori\u0163i s\u0103 ie\u015Fiti?",
  "Restore last draft": "Restaurare la ultima salvare",
  "Special character": "Caractere speciale",
  "Source code": "Codul surs\u0103",
  Language: "Limba",
  "Insert/Edit code sample": "Inserare/Editare mostr\u0103 cod",
  B: "B",
  R: "R",
  G: "G",
  Color: "Culoare",
  "Right to left": "Dreapta la st\xE2nga",
  "Left to right": "St\xE2nga la dreapta",
  Emoticons: "Emoticoane",
  Robots: "Robo\u021Bi",
  "Document properties": "Propriet\u0103\u021Bi document",
  Title: "Titlu",
  Keywords: "Cuvinte cheie",
  Encoding: "Codare",
  Description: "Descriere",
  Author: "Autor",
  Fullscreen: "Pe tot ecranul",
  "Horizontal line": "Linie orizontal\u0103",
  "Horizontal space": "Spa\u021Biul orizontal",
  "Insert/edit image": "Inserare/editarea imaginilor",
  General: "General",
  Advanced: "Avansat",
  Source: "Surs\u0103",
  Border: "Bordur\u0103",
  "Constrain proportions": "Constr\xE2nge propor\u021Biile",
  "Vertical space": "Spa\u021Biul vertical",
  "Image description": "Descrierea imaginii",
  Style: "Stil",
  Dimensions: "Dimensiuni",
  "Insert image": "Inserare imagine",
  Image: "Imagine",
  "Zoom in": "M\u0103rire",
  Contrast: "Contrast",
  Back: "\xCEnapoi",
  Gamma: "Gamma",
  "Flip horizontally": "R\u0103sturn\u0103 orizontal",
  Resize: "Redimensionare",
  Sharpen: "Accentuare",
  "Zoom out": "Mic\u015Forare",
  "Image options": "Op\u021Biuni imagine",
  Apply: "Salveaz\u0103",
  Brightness: "Str\u0103lucire",
  "Rotate clockwise": "Rotire \xEEn sensul orar",
  "Rotate counterclockwise": "Rotire \xEEn sensul antiorar",
  "Edit image": "Editare imagine",
  "Color levels": "Niveluri de culoare",
  Crop: "Decupare",
  Orientation: "Orientare",
  "Flip vertically": "R\u0103sturn\u0103 vertical",
  Invert: "Invers\u0103",
  "Date/time": "Data/ora",
  "Insert date/time": "Insereaz\u0103 data/ora",
  "Remove link": "\u0218terge link-ul",
  Url: "Url",
  "Text to display": "Text de afi\u0219at",
  Anchors: "Ancor\u0103",
  "Insert link": "Inserare link",
  Link: "Link",
  "New window": "Fereastr\u0103 nou\u0103",
  None: "Nici unul",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "URL-ul introdus pare s\u0103 fie o adres\u0103 web. Dori\u021Bi s\u0103 ad\u0103uga\u021Bi prefixul http:// ?",
  "Paste or type a link": "Introduce\u021Bi un link",
  Target: "\u021Aint\u0103",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "URL-ul introdus pare s\u0103 fie o adres\u0103 de e-mail. Dori\u021Bi s\u0103 ad\u0103uga\u021Bi prefixul mailto: ?",
  "Insert/edit link": "Inserare/editare link",
  "Insert/edit video": "Inserare/editare video",
  Media: "Media",
  "Alternative source": "Surs\u0103 alternativ\u0103",
  "Paste your embed code below:": "Insera\u021Bi codul:",
  "Insert video": "Inserare video",
  Poster: "Poster",
  "Insert/edit media": "Inserare/editare media",
  Embed: "Embed",
  "Nonbreaking space": "Spa\u021Biu neseparator",
  "Page break": "\xCEntrerupere de pagin\u0103",
  "Paste as text": "Lipe\u015Fte ca text",
  Preview: "Previzualizare",
  Print: "Tip\u0103re\u0219te",
  Save: "Salveaz\u0103",
  "Could not find the specified string.": "Nu am putut g\u0103si \u0219irul specificat.",
  Replace: "\xCEnlocuie\u015Fte",
  Next: "Precedent",
  "Whole words": "Doar cuv\xEEntul \xEEntreg",
  "Find and replace": "Caut\u0103 \u015Fi \xEEnlocuie\u015Fte",
  "Replace with": "\xCEnlocuie\u015Fte cu",
  Find: "Caut\u0103",
  "Replace all": "\xCEnlocuie\u015Fte toate",
  "Match case": "Distinge majuscule/minuscule",
  Prev: "Anterior",
  Spellcheck: "Verificarea ortografic\u0103",
  Finish: "Finalizeaz\u0103",
  "Ignore all": "Ignor\u0103 toate",
  Ignore: "Ignor\u0103",
  "Add to Dictionary": "Adaug\u0103 \xEEn Dic\u021Bionar",
  "Insert row before": "Insereaz\u0103 \xEEnainte de linie",
  Rows: "Linii",
  Height: "\xCEn\u0103l\u0163ime",
  "Paste row after": "Lipe\u015Fte linie dup\u0103",
  Alignment: "Aliniament",
  "Border color": "Culoare bordur\u0103",
  "Column group": "Grup de coloane",
  Row: "Linie",
  "Insert column before": "Insereaza \xEEnainte de coloan\u0103",
  "Split cell": "\xCEmp\u0103r\u021Birea celulelor",
  "Cell padding": "Spa\u021Biere",
  "Cell spacing": "Spa\u021Biere celule",
  "Row type": "Tip de linie",
  "Insert table": "Insereaz\u0103 tabel\u0103",
  Body: "Corp",
  Caption: "Titlu",
  Footer: "Subsol",
  "Delete row": "\u0218terge linia",
  "Paste row before": "Lipe\u015Fte \xEEnainte de linie",
  Scope: "Domeniu",
  "Delete table": "\u0218terge tabel\u0103",
  "H Align": "Aliniere H",
  Top: "Sus",
  "Header cell": "Antet celul\u0103",
  Column: "Coloan\u0103",
  "Row group": "Grup de linii",
  Cell: "Celul\u0103",
  Middle: "Mijloc",
  "Cell type": "Tip celul\u0103",
  "Copy row": "Copiaz\u0103 linie",
  "Row properties": "Propriet\u0103\u021Bi linie",
  "Table properties": "Propriet\u0103\u021Bi tabel\u0103",
  Bottom: "Jos",
  "V Align": "Aliniere V",
  Header: "Antet",
  Right: "Dreapta",
  "Insert column after": "Insereaza dup\u0103 coloan\u0103",
  Cols: "Coloane",
  "Insert row after": "Insereaz\u0103 dup\u0103 linie",
  Width: "L\u0103\u0163ime",
  "Cell properties": "Propriet\u0103\u021Bi celul\u0103",
  Left: "St\xE2nga",
  "Cut row": "Taie linie",
  "Delete column": "\u0218terge coloana",
  Center: "Centru",
  "Merge cells": "\xCEmbinarea celulelor",
  "Insert template": "Insereaz\u0103 \u0219ablon",
  Templates: "\u015Eabloane",
  "Background color": "Culoare fundal",
  "Custom...": "Personalizat...",
  "Custom color": "Culoare personalizat\u0103",
  "No color": "F\u0103r\u0103 culoare",
  "Text color": "Culoare text",
  "Table of Contents": "Cuprins",
  "Show blocks": "Afi\u0219are blocuri",
  "Show invisible characters": "Afi\u0219are caractere invizibile",
  "Words: {0}": "Cuvinte: {0}",
  Insert: "Insereaz\u0103",
  File: "Fil\u0103",
  Edit: "Editeaz\u0103",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Zon\u0103 cu Rich Text. Apas\u0103 ALT-F9 pentru meniu. Apas\u0103 ALT-F10 pentru bara de unelte. Apas\u0103 ALT-0 pentru ajutor",
  Tools: "Unelte",
  View: "Vezi",
  Table: "Tabel\u0103",
  Format: "Formateaz\u0103"
});